module.exports = __webpack_public_path__ + "static/media/HospedeCosta3.e06f7c77.jpeg";